export default __webpack_public_path__ + "text-ernie3757e9.png";